<div class="financiamento" *ngIf="contractData">
  <div class="contract-hero">
    <div class="contract-hero__client">
      <p class="contract-hero__label">Cliente</p>
      <h2 class="contract-hero__name">{{ contractData.Client || '-' }}</h2>
      <p class="contract-hero__doc">CPF/CNPJ {{ contractData.ClientDocument || '-' }}</p>
    </div>

    <div class="contract-hero__stats">
      <div class="contract-hero__stat">
        <p class="contract-hero__stat-label">Valor do Financiamento</p>
        <p class="contract-hero__stat-value">{{ (contractData.Amount | currency: 'BRL') || '-' }}</p>
      </div>
      <div class="contract-hero__stat">
        <p class="contract-hero__stat-label">Alíquota</p>
        <p class="contract-hero__stat-value">{{ (contractData.Fee !== null && contractData.Fee !== undefined) ? (contractData.Fee | number: '1.0-2') + '%' : '-' }}</p>
      </div>
      <div class="contract-hero__stat">
        <p class="contract-hero__stat-label">Produto</p>
        <p class="contract-hero__stat-value">{{ contractData.Product || '-' }}</p>
      </div>
      <div class="contract-hero__stat">
        <p class="contract-hero__stat-label">Banco</p>
        <p class="contract-hero__stat-value">{{ (contractData.FinancialInstitution | titlecase) || '-' }}</p>
      </div>
    </div>
  </div>

  <ng-container *ngIf="isLoading">
    <app-skeleton variant="card" [lines]="3"></app-skeleton>
    <div class="financiamento__movements ui-card">
      <app-skeleton variant="table-row" [rows]="3" [columns]="9"></app-skeleton>
    </div>
  </ng-container>

  <ng-container *ngIf="!isLoading">
  <app-kpi-row *ngIf="kpis.length" class="financiamento__kpis" [items]="kpis" layout="cards"></app-kpi-row>

  <div class="financiamento__movements ui-card">
    <div class="financiamento__movements-header">
      <p class="financiamento__section-title">Movimentações</p>
      <p class="financiamento__section-subtitle">Faturamentos, estornos e refaturamentos deste contrato</p>
    </div>

    <div class="movements-table" *ngIf="movements.length; else noMovements">
      <table>
        <thead>
          <tr>
            <th>Movimento</th>
            <th>Contrato</th>
            <th>Lote</th>
            <th>NF</th>
            <th>Emissão NF</th>
            <th>Valor Financiado</th>
            <th>% Com.</th>
            <th>Comissão</th>
            <th>Status no Banco</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let movement of movements" [class.movements-table__row--cancelled]="isLoteCancelado(movement)">
            <td>
              <app-status-badge [label]="movement.Tipo" [tone]="movementTypeTone(movement.Tipo)" variant="outline" size="sm"></app-status-badge>
              <span class="movements-table__invoicing-status" *ngIf="movement.InvoicingStatus" [matTooltip]="'Status do faturamento desta versão do contrato: ' + movement.InvoicingStatus">
                <b>Status</b> {{ movement.InvoicingStatus }}
              </span>
            </td>
            <td>
              <span class="movements-table__contract-row">
                <span class="movements-table__contract-number">{{ movement.Contrato || '-' }}</span>
                <span *ngIf="movement.Version !== null && movement.Version !== undefined"
                      class="movements-table__version-tag">
                  v{{ movement.Version }}
                </span>
              </span>
              <span class="movements-table__query-number" *ngIf="movement.QueryNumber" [matTooltip]="'Consulta: ' + movement.QueryNumber">
                {{ movement.QueryNumber }}
              </span>
            </td>
            <td>
              <span class="movements-table__lote">{{ movement.Lote || '-' }}</span>
              <span class="movements-table__lote-status" *ngIf="movement.LoteStatus">
                {{ movement.LoteStatus }}
              </span>
            </td>
            <td>{{ movement.Nf || '-' }}</td>
            <td>{{ movement.DataEmissao | date: 'dd/MM/yyyy' }}</td>
            <td class="movements-table__amount">{{ movement.Valor | currency: 'BRL' }}</td>
            <td>{{ formatPercent(movement.Percentual) }}</td>
            <td class="movements-table__amount">{{ movement.Comissao | currency: 'BRL' }}</td>
            <td><app-status-badge [label]="movement.Status" [tone]="movementTone(movement)" variant="outline"></app-status-badge></td>
          </tr>
        </tbody>
      </table>

      <div class="financiamento__situacao-vigente">
        <div class="financiamento__situacao-item">
          <p class="financiamento__situacao-label">Saldo Faturado</p>
          <p class="financiamento__situacao-value">{{ saldoFaturado }}</p>
        </div>
        <div class="financiamento__situacao-item">
          <p class="financiamento__situacao-label">Comissão Vigente</p>
          <p class="financiamento__situacao-value">{{ comissaoVigente }}</p>
        </div>
      </div>
    </div>

    <ng-template #noMovements>
      <div class="ui-empty-state">
        <span class="ui-empty-state__message">Não há movimentações disponíveis</span>
      </div>
    </ng-template>
  </div>

  <div class="contract-card" *ngIf="currentSituation">
    <h3 class="contract-card__title"><span class="contract-card__bar"></span>Situação vigente</h3>
    <div class="contract-card__grid">
      <div class="contract-field">
        <p class="contract-field__label">Status do Faturamento</p>
        <p class="contract-field__value">{{ currentSituation.StatusFaturamento || '-' }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Tipo de Faturamento</p>
        <p class="contract-field__value">{{ currentSituation.TipoFaturamento || '-' }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Nota Fiscal Vigente</p>
        <p class="contract-field__value">{{ currentSituation.NotaFiscalVigente || '-' }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Data de Emissão da NF</p>
        <p class="contract-field__value">{{ (currentSituation.DataEmissaoNf | date: 'dd/MM/yyyy') || '-' }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Lote de Faturamento</p>
        <p class="contract-field__value">{{ currentSituation.LoteFaturamento || '-' }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Lote de Repasse</p>
        <p class="contract-field__value">{{ currentSituation.LoteRepasse || '-' }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Status no Banco</p>
        <p class="contract-field__value">{{ currentSituation.StatusNoBanco || '-' }}</p>
      </div>
      <div class="contract-field">
        <p class="contract-field__label">Contrato de Origem</p>
        <p class="contract-field__value">{{ currentSituation.ContratoOrigem || '-' }}</p>
      </div>
    </div>
  </div>
  </ng-container>
</div>
